<template>
  <div class="anytime-consultation-search">
    <!-- ▼ 追加検索条件ダイアログ -->
    <v-dialog
      v-model="searchConditionDialog"
      max-width="60%"
    >
      <v-col
        text-md-center
        style="position: relative"
      >
        <v-container
          style="background-color: #eee; max-height: calc(100vh - 48px); overflow: auto;"
        >
          <div
            v-if="query.departmentType == 'pediatrician'"
            class="d-flex p-searchDetail"
          >
            <div class="py-3 px-1 p-searchDetail__key">
              <div class="p-searchDetail__key__title">
                <b>年齢</b>
              </div>
              <div class="p-searchDetail__key__caption">
                子どもの年齢
              </div>
            </div>
            <div class="py-3 px-1 p-searchDetail__input">
              <ChildAgeRangeSlider v-model="tmpQuery.childAgeRange" />
            </div>
          </div>
          <div
            v-if="query.departmentType == 'pediatrician'"
            class="d-flex p-searchDetail"
          >
            <div class="py-3 px-1 p-searchDetail__key">
              <div class="p-searchDetail__key__title">
                <b>性別</b>
              </div>
              <div class="p-searchDetail__key__caption">
                子どもの性別
              </div>
            </div>
            <div class="py-3 px-1 d-flex flex-wrap p-searchDetail__input">
              <div
                v-for="option in options.childSex"
                :key="option.value"
              >
                <v-checkbox
                  v-model="query.childSex"
                  :value="option.value"
                  :label="option.text"
                  class="ma-2"
                  :data-test="`childSex-checkbox-${option.value}`"
                  hide-details
                />
              </div>
            </div>
          </div>
          <div
            v-if="query.departmentType != 'pediatrician'"
            class="d-flex p-searchDetail"
          >
            <div class="py-3 px-1 p-searchDetail__key">
              <div class="p-searchDetail__key__title">
                <b>年齢</b>
              </div>
              <div class="p-searchDetail__key__caption">
                相談者
              </div>
            </div>
            <div class="py-3 px-1 d-flex flex-wrap p-searchDetail__input">
              <div
                v-for="option in options.userAgeRank"
                :key="option.value"
              >
                <v-checkbox
                  v-model="query.userAgeRank"
                  :value="option.value"
                  :label="option.text"
                  class="ma-2"
                  :data-test="`userAgeRank-checkbox-${option.value}`"
                  hide-details
                />
              </div>
            </div>
          </div>
          <div
            v-if="query.departmentType != 'pediatrician'"
            class="d-flex p-searchDetail"
          >
            <div class="py-3 px-1 p-searchDetail__key">
              <div class="p-searchDetail__key__title">
                <b>妊娠状況</b>
              </div>
              <div class="p-searchDetail__key__caption">
                相談者
              </div>
            </div>
            <div class="py-3 px-1 d-flex flex-wrap p-searchDetail__input">
              <div
                v-for="option in options.inPregnancy"
                :key="option.value"
              >
                <v-checkbox
                  v-model="query.inPregnancy"
                  :value="option.value"
                  :label="option.text"
                  class="ma-2"
                  :data-test="`inPregnancy-checkbox-${option.value}`"
                  hide-details
                />
              </div>
            </div>
          </div>
          <div
            v-if="query.departmentType != 'pediatrician'"
            class="d-flex p-searchDetail"
          >
            <div class="py-3 px-1 p-searchDetail__key">
              <div class="p-searchDetail__key__title">
                <b>妊娠週数</b>
              </div>
              <div class="p-searchDetail__key__caption">
                相談者<br>(妊娠中のみ)
              </div>
            </div>
            <div class="py-3 px-1 d-flex flex-wrap p-searchDetail__input">
              <div
                v-for="option in options.weeksOfPregnancyRank"
                :key="option.value"
              >
                <v-checkbox
                  v-model="query.weeksOfPregnancyRank"
                  :value="option.value"
                  :label="option.text"
                  class="ma-2"
                  hide-details
                />
              </div>
            </div>
          </div>
          <div
            v-if="query.departmentType != 'pediatrician'"
            class="d-flex p-searchDetail"
          >
            <div class="py-3 px-1 p-searchDetail__key">
              <div class="p-searchDetail__key__title">
                <b>産後月数</b>
              </div>
              <div class="p-searchDetail__key__caption">
                相談者<br>(産後のみ)
              </div>
            </div>
            <div class="py-3 px-1 d-flex flex-wrap p-searchDetail__input">
              <div
                v-for="option in options.monthsOfPostpartumRank"
                :key="option.value"
              >
                <v-checkbox
                  v-model="query.monthsOfPostpartumRank"
                  :value="option.value"
                  :label="option.text"
                  class="ma-2"
                  hide-details
                />
              </div>
            </div>
          </div>
          <div class="d-flex p-searchDetail">
            <div class="py-3 px-1 p-searchDetail__key">
              <div class="p-searchDetail__key__title">
                <b>回答者名</b>
              </div>
              <div class="p-searchDetail__key__caption">
                回答者氏名<br>(部分一致)
              </div>
            </div>
            <div class="py-3 px-1 d-flex flex-wrap p-searchDetail__input">
              <DoctorNameInput
                :family-name="query.doctorFamilyName"
                :first-name="query.doctorFirstName"
                :disabled="query.doctorId != null"
                :field-attrs="{ class: 'pt-1 ml-2 mr-6', style: 'max-width: 120px;' }"
                @update:family-name="query.doctorFamilyName = $event"
                @update:first-name="query.doctorFirstName = $event"
              />
            </div>
          </div>
          <div class="d-flex p-searchDetail">
            <div class="py-3 px-1 p-searchDetail__key">
              <div class="p-searchDetail__key__title">
                <b>気になっていること</b>
              </div>
              <div class="p-searchDetail__key__caption">
                事前問診より
              </div>
            </div>
            <div class="py-3 px-1 d-flex flex-wrap p-searchDetail__input">
              <div
                v-for="option in options.userInterest"
                :key="option.value"
              >
                <v-checkbox
                  v-model="query.userInterest"
                  :value="option.value"
                  :label="option.text"
                  class="ma-2"
                  :data-test="`userInterest-checkbox-${option.value}`"
                  hide-details
                />
              </div>
            </div>
          </div>

          <div class="text-center">
            <v-btn
              color="grey-darken-4"
              density="comfortable"
              @click="closeSearchConditionDialog"
            >
              完了
            </v-btn>
          </div>
        </v-container>
        <v-btn
          position="absolute"
          class="icon-button"
          color="gray-lighten-4"
          fab
          size="x-small"
          @click="closeSearchConditionDialog"
        >
          ×
        </v-btn>
      </v-col>
    </v-dialog>

    <!-- ▼ 管理者向けダイアログ -->
    <v-dialog
      v-model="optionDialog"
      max-width="60%"
    >
      <v-col
        text-md-center
        style="position: relative"
      >
        <v-container style="background-color: #eee;">
          <!-- 並び順, スコア表示など -->
          <div class="d-flex p-searchDetail">
            <div class="py-3 px-1 p-searchDetail__key">
              <div class="p-searchDetail__key__title">
                <b>並び順</b>
              </div>
            </div>
            <div class="py-3 px-1 d-flex flex-wrap p-searchDetail__input">
              <v-radio-group
                v-model="query.sortRules"
                inline
                density="compact"
                class="ma-0"
                hide-details
              >
                <v-radio
                  v-for="option in options.sortRules"
                  :key="option.value"
                  :label="option.text"
                  :value="option.value"
                />
              </v-radio-group>
            </div>
          </div>
          <div class="d-flex p-searchDetail">
            <div class="py-3 px-1 p-searchDetail__key">
              <div class="p-searchDetail__key__title">
                <b>スコア表示</b>
              </div>
              <div class="p-searchDetail__key__caption">
                (動作検証用)
              </div>
            </div>
            <div class="py-3 px-1 d-flex flex-wrap p-searchDetail__input">
              <v-checkbox
                v-model="query.displayScore"
                label="検索スコアを表示する"
                class="ma-2"
                hide-details
              />
            </div>
          </div>
        </v-container>
      </v-col>
    </v-dialog>

    <!-- ▼ 検索フォーム本体 -->
    <v-container
      fluid
      class="p-searchConditions bg-grey-lighten-3"
    >
      <!-- 診療科 -->
      <v-row
        :dense="true"
        style="border-bottom: 1px solid #ddd;"
      >
        <v-col cols="3">
          <div class="pa-2">
            <b>相談員種別</b>
          </div>
        </v-col>
        <v-col cols="9">
          <v-radio-group
            v-model="query.departmentType"
            inline
            density="compact"
            class="ma-0"
            hide-details
          >
            <v-radio
              v-for="option in options.departmentType"
              :key="option.value"
              :label="option.text"
              :value="option.value"
              :data-test="`departmentType-radio-${option.value}`"
              class="mr-2"
            />
          </v-radio-group>
          <OnlyMyAnswerCheckbox
            v-model="query.doctorId"
            :current-doctor="currentDoctor"
            data-test="onlyMyAnswer-checkbox"
          />
        </v-col>
      </v-row>

      <!-- キーワード -->
      <v-row
        :dense="true"
        class="pt-2"
      >
        <v-col cols="3">
          <div class="pa-2">
            <b>キーワード</b>
          </div>
        </v-col>
        <v-col cols="9">
          <v-text-field
            v-model="query.answerKeywords"
            data-test="answerKeywords-field"
            density="compact"
            hide-details
            class="pa-0"
            placeholder="スペース区切り キーワード"
          />
        </v-col>
      </v-row>

      <!-- 検索範囲 -->
      <v-row no-gutters>
        <v-col cols="3">
          <div
            class="pa-2 ml-2"
            style="font-size: 12.8px;"
          >
            検索範囲
          </div>
        </v-col>
        <v-col cols="9">
          <div class="d-flex">
            <div
              v-for="option in options.answerKeywordScopes"
              :key="option.value"
            >
              <v-checkbox
                v-model="query.answerKeywordScopes"
                :value="option.value"
                :label="option.text"
                :data-test="`answerKeywordScopes-checkbox-${option.value}`"
                class="mt-1 mr-3 c-checkbox--mini"
                density="compact"
                hide-details
              />
            </div>
          </div>
        </v-col>
      </v-row>

      <!-- 暫定診断 -->
      <v-row
        :dense="true"
        class="pt-2"
        style="border-top: 1px solid #ddd;"
      >
        <v-col cols="3">
          <div class="pa-2">
            <b>暫定診断</b>
          </div>
        </v-col>
        <v-col cols="9">
          <Icd10KeywordInput
            v-model="query.icd10Keyword"
            input-id="icd10SearchField"
            class="pa-0"
            placeholder="診断名を検索"
          />
        </v-col>
      </v-row>

      <Icd10CandidatesPanel
        :visible="hasOnceSearched && !isSearching && query.icd10Keyword.length === 0 && topFiveIcdBranch.length > 0"
        :candidates="topFiveIcdBranch"
        @select="setIcd10Keyword"
      />

      <!-- 追加条件 -->
      <v-row style="border-top: 1px solid #ddd; border-bottom: 1px solid #ddd;">
        <v-col cols="3">
          <div class="pa-2">
            <b>追加条件</b>
          </div>
        </v-col>
        <v-col cols="9">
          <div class="py-2">
            <div v-if="displayQuery.length > 0">
              {{ displayQuery }}
            </div>
            <a
              style="cursor: pointer;"
              @click="openSearchConditionDialog"
            >
              ＋ 設定する
            </a>
          </div>
        </v-col>
      </v-row>

      <!-- 管理者向け -->
      <v-row
        v-if="isOperator"
        style="border-bottom: 1px solid #ddd;"
      >
        <v-col cols="3">
          <div class="pa-2">
            <b>管理者向け</b>
          </div>
        </v-col>
        <v-col cols="9">
          <div class="py-2">
            <div v-if="displayOption.length > 0">
              {{ displayOption }}
            </div>
            <a
              style="cursor: pointer;"
              @click="openOptionDialog"
            >
              ＋ 設定する
            </a>
          </div>
        </v-col>
      </v-row>

      <!-- 検索ボタン -->
      <v-row :dense="true">
        <v-col class="text-center">
          <v-btn
            color="grey-darken-4"
            density="comfortable"
            data-test="search-button"
            @click="updateList"
          >
            検索
          </v-btn>
        </v-col>
      </v-row>
    </v-container>

    <!-- ▼ 検索結果表示 -->
    <div v-if="hasOnceSearched">
      <!-- エラー表示 -->
      <div
        v-if="elasticsearchErrorDetail.length > 0"
        class="pa-6"
      >
        <div v-html="structuredElasticsearchErrorDetail" />
      </div>
      <!-- 読込中アニメーション -->
      <div
        v-else-if="isSearching"
        class="pa-6 text-center"
      >
        <v-progress-circular
          indeterminate
          color="grey"
        />
        <p class="pa-2">
          検索中...
        </p>
      </div>
      <!-- ヒット件数 -->
      <template v-else>
        <div class="pa-4">
          <template v-if="hit >= 100">
            100件以上ヒット/関連度順に表示(最初の100件のみを表示)
          </template>
          <template v-else>
            {{ hit }}件ヒット/関連度順に表示
          </template>
        </div>
        <!-- 検索結果一覧 -->
        <div v-if="anytimeConsultations.length > 0">
          <AnytimeConsultationElasticSearchResult
            v-for="anytimeConsultation in anytimeConsultations"
            :key="anytimeConsultation.id"
            class="pt-0 pb-4 pr-6 pl-12"
            :consultation="anytimeConsultation"
            :keywords="previousSplitKeywords"
          />
        </div>
        <div
          v-else
          class="pa-4"
        >
          検索条件に一致する事例はありませんでした。<br>
          検索条件を変えて、もう一度お試しください。
        </div>
      </template>
    </div>
    <!-- ▼ 検索前の案内文 -->
    <div
      v-else
      class="pa-6"
    >
      過去のいつでも相談の回答から、参考になる回答を探すことができます。<br>
      検索条件を入力し、「検索」ボタンを押してください。<br>
      <br>
      「◀︎」「▶」ボタンを押すことで、このエリアの大きさを調整できます。
    </div>
  </div>
</template>

<script lang="ts">
import { mapGetters, mapActions } from "vuex";
import AnytimeConsultationElasticSearchResult from "../../../components/shared/sidebar/Search/AnytimeConsultationElasticSearchResult.vue";
import Icd10CandidatesPanel from "./Icd10CandidatesPanel.vue";
import ChildAgeRangeSlider from "../../../shared/ui/ChildAgeRangeSlider.vue";
import Icd10KeywordInput from "../../../shared/ui/Icd10KeywordInput.vue";
import DoctorNameInput from "../../../shared/ui/DoctorNameInput.vue";
import OnlyMyAnswerCheckbox from "../../../shared/ui/OnlyMyAnswerCheckbox.vue";
import { childAgeMonthLabel } from "../../../shared/utils/childAge";
import { syncDoctorNameByDoctorId } from "../../../shared/utils/doctorFilter";
import type { SearchTabOptions, SearchTabQuery } from "../../../features/anytime-consultation-similar-search/model/searchOptions";
import {
  SEARCH_TAB_OPTIONS,
  createDefaultSearchTabQuery,
  applyChildAgeRangeToQuery,
  buildSearchTabRequestQuery,
  cloneSearchTabQuery,
  splitSearchKeywords,
  buildSearchTabDisplayQuery,
  buildSearchTabDisplayOption,
  buildTopIcd10Candidates
} from "../../../features/anytime-consultation-similar-search";

export default {
  name: "AnytimeConsultationSimilarSearchPanel",
  components: {
    AnytimeConsultationElasticSearchResult,
    Icd10CandidatesPanel,
    ChildAgeRangeSlider,
    Icd10KeywordInput,
    DoctorNameInput,
    OnlyMyAnswerCheckbox
  },
  expose: ["start", "clear"],
  data(): {
    query: SearchTabQuery;
    tmpQuery: {
      childAgeRange: number[];
    };
    previousQuery: SearchTabQuery;
    options: SearchTabOptions;
    hasOnceSearched: boolean;
    } {
    return {
      // 検索条件
      query: createDefaultSearchTabQuery(),
      // UIで使うための一時的な変数
      tmpQuery: {
        childAgeRange: [0, 35], // 月齢の範囲
      },
      // 前回検索キーワードの保持
      previousQuery: createDefaultSearchTabQuery(),
      // 追加のオプション類
      options: SEARCH_TAB_OPTIONS,
      hasOnceSearched: false // 一度検索したかどうか
    };
  },
  computed: {
    // ================================
    // mapGetters で検索に必要な情報を取得
    // ================================
    ...mapGetters([
      "isSearching",
      "anytimeConsultation",
      "anytimeConsultations",
      "elasticsearchErrorDetail",
      "currentDoctor",
      "hasAllCapabilities"
    ]),

    // ================================
    // 検索結果の件数
    // ================================
    hit() {
      return this.anytimeConsultations.length;
    },

    // ================================
    // 過去検索キーワード
    // ================================
    previousSplitKeywords() {
      if (!this.previousQuery) return [];
      return splitSearchKeywords(this.previousQuery.answerKeywords);
    },

    // ================================
    // icd10 検索候補など
    // ================================
    topFiveIcdBranch() {
      return buildTopIcd10Candidates(this.anytimeConsultations);
    },

    // ================================
    // 管理者向けフラグ
    // ================================
    isOperator() {
      return this.hasAllCapabilities(["operator:access"]);
    },

    // ================================
    // ダイアログ用のv-model計算 (store管理)
    // ================================
    optionDialog: {
      get() {
        return Boolean(this.showOptionDialog); // store から
      },
      set(val: boolean) {
        if (val) this.openOptionDialog();
        else this.closeOptionDialog();
      }
    },
    searchConditionDialog: {
      get() {
        return Boolean(this.showSearchConditionDialog); // store から
      },
      set(val: boolean) {
        if (val) this.openSearchConditionDialog();
        else this.closeSearchConditionDialog();
      }
    },

    // ================================
    // 表示用のまとめ
    // ================================
    displayQuery() {
      return buildSearchTabDisplayQuery({
        query: this.query,
        tmpQuery: this.tmpQuery,
        options: this.options,
        childAgeMonthLabel
      });
    },
    displayOption() {
      return buildSearchTabDisplayOption({
        query: this.query,
        options: this.options
      });
    },

    // ================================
    // 検索エラーの詳細を整形
    // ================================
    structuredElasticsearchErrorDetail: function () {
      const sanitize = (this as unknown as { $sanitize: Function }).$sanitize;
      const content = sanitize(this.elasticsearchErrorDetail);
      if (typeof content !== "string" || content.length == 0) {
        return "";
      }
      return content.replaceAll(/\r\n/g, "<br>").replace(/\r/g, "<br>").replace(/\n/g, "<br>");
    },

    // ================================
    // storeのSidebar用Getterを利用
    // ================================
    ...mapGetters([
      "showOptionDialog",
      "showSearchConditionDialog"
    ])
  },
  mounted: function () {
    // 「子どもの月齢」スライダーの値が変わった時の処理
    this.$watch(
      "tmpQuery.childAgeRange",
      (newRange: number[]) => {
        applyChildAgeRangeToQuery(this.query, newRange);
      },
      { deep: true }
    );

    // 「自分の回答のみ表示」ON/OFF切り替え時の処理
    this.$watch(
      "query.doctorId",
      (doctorId: number | null) => {
        syncDoctorNameByDoctorId({
          doctorId,
          currentDoctor: this.currentDoctor,
          setFamilyName: (value: string) => {
            this.query.doctorFamilyName = value;
          },
          setFirstName: (value: string) => {
            this.query.doctorFirstName = value;
          }
        });
      }
    );
  },
  unmounted: function () {
    // コンポーネントがアンマウントされる時に、検索タブのオブジェクトをクリア
    this.clearAnytimeConsultationSearchTabObjects();
  },
  methods: {
    ...mapActions([
      "similarSearchAnytimeConsultations",  // 検索アクション
      "openSearchConditionDialog",
      "closeSearchConditionDialog",
      "openOptionDialog",
      "closeOptionDialog",
      "clearAnytimeConsultationSearchTabObjects"
    ]),

    // ================================
    // 検索実行
    // ================================
    updateList() {
      const requestQuery = buildSearchTabRequestQuery(this.query);

      this.similarSearchAnytimeConsultations({
        id: this.$route.params.id,
        query: requestQuery
      })
        .then(() => {
          // 成功時
        })
        .catch(() => {
          // Promiseでrejectしているのでcatchしておく
        });
      this.previousQuery = cloneSearchTabQuery(this.query);
      this.hasOnceSearched = true;
    },
    // 必要なデータのfetchが完了しているか確認し、検索を実行
    start(){
      if (!this.hasOnceSearched && this.anytimeConsultation) {
        // クエリの初期化
        this.query.departmentType = this.anytimeConsultation.department_type;

        // 検索を実行
        this.updateList();
      }
    },
    clear(){
      this.query = createDefaultSearchTabQuery();
      this.tmpQuery = { childAgeRange: [0, 35] };
      this.previousQuery = createDefaultSearchTabQuery();
      this.hasOnceSearched = false;
      this.clearAnytimeConsultationSearchTabObjects();
    },

    setIcd10Keyword(name: string) {
      this.query.icd10Keyword = name;
    },


  }
};
</script>

<style lang="scss">

.c-checkbox--mini {
  .v-label {
    font-size: 0.8em !important;
  }

  .v-input--selection-controls__input {
    margin-right: 0px !important;
  }

  .v-input--selection-controls__ripple {
    height: 31px;
    width: 31px;
    top: calc(50% - 23px);
  }

  .v-icon {
    font-size: 21px !important;
  }
}

.c-switch--mini {
  .v-label {
    font-size: 0.8em !important;
  }
}

.c-radio--mini {
  .v-label {
    font-size: 0.8em !important;
  }

  .v-input--selection-controls__input {
    margin-right: 0px !important;
  }

  .v-input--selection-controls__ripple {
    height: 31px;
    width: 31px;
    top: calc(50% - 23px);
  }

  .v-icon {
    font-size: 21px !important;
  }
}

.p-searchConditions {
  .v-messages {
    min-height: 0px !important;
  }

  .v-input__slot {
    margin: 0;
  }

  .icd10Search {
    .icd10ResultField {
      position: relative;
    }

    .icd10ListWrap {
      z-index: 2;
      position: absolute;
      width: 100%;
      top: 0;

      .icd10ListArea {
        max-height: 150px;
        border: solid 1px #000000;
        margin: 0 auto;
        overflow: auto;
        background-color: #ffffff;
      }

      p {
        margin: 0;
        text-align: left;
        border: solid 1px #d2d2d2;

        a {
          display: inline-block;
          width: 100%;

          &:hover {
            background-color: #ccc;
          }
        }
      }
    }
  }
}

.p-searchDetail {
  &+& {
    border-top: 1px solid #ccc;
  }

  &__key {
    width: 120px;
    display: flex;
    flex-direction: column;
    justify-content: center;

    &__caption {
      font-size: 0.7em;
      color: #666
    }
  }

  &__input {
    width: calc(100% - 120px);
  }
}

.p-searchDetail {
  &+& {
    border-top: 1px solid #ccc;
  }

  &__key {
    width: 120px;
  }

  &__input {
    width: calc(100% - 120px);
  }
}
</style>
